import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '@api/services/authorization/token.service';
import { UserImageService } from '@api/services/user/user-image.service';
import { SmartyCubeStorageKeys } from '@core/config';
import { LoginUserService, OptionsValues, SessionStorageService } from '@smartera/core';
import { User } from '@api/models/user/user';
import { LoginDialogService } from '@core/services/login-dialog.service';
import { UtilityService } from '@core/services/utility.service';

import { SmartyGptComponent } from '@feature/smart-reports-core/components/smarty-gpt/components/smarty-gpt.component';
import { ElasticSearchIndexService, ESIndex } from '@feature/smart-reports-core/services';
import { BaseComponent } from '@modules/components/base-component';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-page',
	templateUrl: './page.component.html',
	styleUrls: ['./page.component.scss'],
	standalone: false,
})
export class PageComponent extends BaseComponent implements OnInit, AfterViewInit {
	readonly environment = environment;
	public items: MenuItem[];

	override states = {
		isSmartyGptDialogVisible: false,
		isSmartyGptDialogMinimize: false,
	};

	selectedIndexId: string;
	selectedEsIndex: ESIndex;
	indexList: ESIndex[];
	indexOptions: OptionsValues;
	isShowInteractiveDemoDislay: boolean = false;

	@ViewChild('smartyGpt') smartyGptComponent: SmartyGptComponent;

	constructor(
		utilServ: UtilityService,
		private _loginUserService: LoginUserService,
		public userImage: UserImageService,
		public tokenService: TokenService,
		public loginDialogService: LoginDialogService,
		private sessionStorageService: SessionStorageService,
		private elasticSearchIndexService: ElasticSearchIndexService,
		private router: Router
	) {
		super(null, utilServ);
	}

	ngOnInit(): void {
		// if (this._loginUserService.isValidLogin() === false) {
		// 	this.router.navigateByUrl('/login');
		// }
		this.tokenService.isTokenExpired.subscribe((value) => {
			this.isDialogVisible = value;
		});
		const user = this._loginUserService.user as unknown as User;
		if (user.image) {
			this.userImage.update(user.image.id);
		}
		this.elasticSearchIndexService.getList({ valid: true }).subscribe((res: ESIndex[]) => {
			this.indexList = res;
			this.indexOptions = res.map((item) => ({ label: item['description'], value: item['id'] }));
		});

		this.checkAndShowInteractiveDemoDisplayByCurrentUser();
	}

	public ngAfterViewInit(): void {
		this.hideloader();
		const fontSize = localStorage.getItem('fontSize') || 'f-normal';

		document.querySelector('#main-container').className = fontSize;
	}

	nav(id: string): void {
		this.utilServ.alertService.error(this.t('g.error'), this.t('youDontHavePermistion'));
	}

	routeToLogin(): void {
		this.sessionStorageService.clearAll();
		this.router.navigateByUrl('/login');
	}

	showSmartyGptDialog(): void {
		const { isSmartyGptDialogVisible } = this.states;
		if (!isSmartyGptDialogVisible) {
			this.states.isSmartyGptDialogVisible = true;
		} else {
			this.states.isSmartyGptDialogMinimize = false;
		}
	}

	selectIndex(indexId: string): void {
		this.selectedEsIndex = this.indexList.find((item) => item.id === indexId);
		setTimeout(() => {
			this.smartyGptComponent.init();
		}, 1);
	}

	minimizeSmartyGptDialog(): void {
		this.states.isSmartyGptDialogMinimize = true;
	}

	hideSmartyGptDialog(): void {
		this.states.isSmartyGptDialogVisible = false;
		this.states.isSmartyGptDialogMinimize = false;
		this.selectedEsIndex = null;
		this.selectedIndexId = null;
	}

	private checkAndShowInteractiveDemoDisplayByCurrentUser(): void {
		const usersShownInteractiveDemoString = localStorage.getItem(SmartyCubeStorageKeys.USERS_SHOWN_INTERACTIVE_DEMO);
		const usersShownInteractiveDemo = usersShownInteractiveDemoString
			? JSON.parse(usersShownInteractiveDemoString)
			: [];

		this.isShowInteractiveDemoDislay = !usersShownInteractiveDemo.includes(this.user.id);

		if (!usersShownInteractiveDemo.includes(this.user.id)) {
			usersShownInteractiveDemo.push(this.user.id);
			localStorage.setItem(
				SmartyCubeStorageKeys.USERS_SHOWN_INTERACTIVE_DEMO,
				JSON.stringify(usersShownInteractiveDemo)
			);
		}
	}
}
